import type { Query, QueryClient } from '@tanstack/react-query';

import { jobArchitectureKeys } from './query-keys';

const [root, scope, , kind] = jobArchitectureKeys.archLevelingFrameworks('');

/**
 * Other job architectures' cached frameworks say which job architectures use them, so they go stale once
 * this one starts or stops using a shared framework. Unused caches are dropped, so a later visit loads
 * fresh instead of showing the old list first.
 */
export const dropOtherArchitecturesLevelingFrameworks = (queryClient: QueryClient, jobArchitectureId: string): void => {
    const isOtherArchitectureFrameworkQuery = ({ queryKey }: Query): boolean =>
        queryKey[0] === root && queryKey[1] === scope && queryKey[2] !== jobArchitectureId && queryKey[3] === kind;

    queryClient.removeQueries({ predicate: isOtherArchitectureFrameworkQuery, type: 'inactive' });
    void queryClient.invalidateQueries({ predicate: isOtherArchitectureFrameworkQuery });
};
